import {ConsumerReportsIndexRequest} from "@/core/http/resources/BackingResource";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {backingApi} from "@/container";

/**
 * Composable to fetch backing consumer reports.
 */
const useConsumerBackingReports = (consumerKey: string, backingId: number, params: ConsumerReportsIndexRequest) => {
    return useSwr(
        () => cacheKey(`consumers/${consumerKey}/backings/${backingId}/reports`, params),
        () => backingApi().indexConsumerReports(consumerKey, backingId, params)
    );
};

export default useConsumerBackingReports;
